module.exports = __webpack_public_path__ + "static/media/Review.f5ed2e33.jpg";